import { Box } from "@mui/material";
import { Image } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

interface ActionBannerIconWrapperProps {
  imageSource: string;
  imageAlt: string;
}

export function ActionBannerIconWrapper(props: ActionBannerIconWrapperProps) {
  const { imageSource, imageAlt } = props;
  const theme = getTheme();

  return (
    <Box
      sx={(theme) => ({
        width: theme.size?.iconButton.small.size,
        height: theme.size?.iconButton.small.size,
        background: theme.palette.documents?.error.gradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.borderRadius?.small,
        flexShrink: 0,
      })}
    >
      <Image src={imageSource} width={theme.size?.icon.medium} alt={imageAlt} />
    </Box>
  );
}
